import React, { useEffect } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import IranFlag from "Assets/Images/Iran.svg";
import EnFlag from "Assets/Images/en.svg";
import ArFlag from "Assets/Images/arpng.png";
import { showHidden, beEnglish } from 'Components/API'
import { ReactComponent as ChevronDown } from 'Assets/icons/chevronDown.svg';
import { ReactComponent as FlagIran } from 'Assets/icons/flagIran.svg';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (beEnglish) {
            i18n.changeLanguage("en");
        } else {
            const savedLang = localStorage.getItem("language");
            i18n.changeLanguage(savedLang || "fa");
        }
    }, [beEnglish]);

    const handleLanguageChange = (e) => {
        const newLang = e.target.value;

        // تغییر زبان
        i18n.changeLanguage(newLang);
        localStorage.setItem("language", newLang);

        // بررسی می‌کنیم که آیا در صفحه خبر هستیم یا نه
        const isNewsPage = location.pathname.includes('/Media/News/Post/');

        if (isNewsPage) {
            // اگر در صفحه خبر هستیم
            if (newLang === 'fa') {
                // برای فارسی، پارامتر lang را حذف می‌کنیم
                navigate(location.pathname, { replace: true });
            } else {
                // برای انگلیسی و عربی، پارامتر lang را اضافه می‌کنیم
                const searchParams = new URLSearchParams(location.search);
                searchParams.set('lang', newLang);
                const newUrl = `${location.pathname}?${searchParams.toString()}`;
                navigate(newUrl, { replace: true });
            }
        }
        // اگر در صفحه خبر نباشیم، فقط زبان تغییر می‌کند
    };

    useEffect(() => {
        document.body.setAttribute('lang', i18n.language);
        document.body.dir = i18n.language === 'en' ? 'ltr' : 'rtl';
    }, [i18n.language]);

    return (
        <Select
            className="language-bar-select"
            labelId="select-language"
            id="demo-simple-select"
            value={i18n.language}
            label="زبان"
            onChange={handleLanguageChange}
            IconComponent={(props) => (
                <ChevronDown
                    style={{ color: "#fff", top: '11px' }}
                    {...props}
                />
            )}
        >
            <MenuItem className="d-flex justify-content-between" value="fa">FA <FlagIran className="me-2" /></MenuItem>
            <MenuItem className="d-flex justify-content-between" value="en">En <img src={EnFlag} className="me-2" width="18px" alt="English" /> </MenuItem>
            <MenuItem className="d-flex justify-content-between" value="ar">AR <img src={ArFlag} className="me-2" width="18px" alt="Arabic" /></MenuItem>
        </Select>
    );
};

export default LanguageSwitcher;